module.exports = __webpack_public_path__ + "static/media/laurel.c3e57644.png";